// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budget-btn {
    display: inline-block;
    background-color: #54595F !important;
    color: #fff;
    text-decoration: none;
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    padding: 0.8rem 3.5rem !important;
    border: none !important;
    cursor: pointer !important;
    font-family: inherit !important;
    transition: all 0.3s !important;
}

.btn-create-budget:hover,
.btn-delete-budget-cancel:hover,
.argent-background,
.time-background,
.budget-btn:hover {
    background-color: #61CE70 !important;
    color: #000000 !important;
}

.budget-btn-create {
    border-radius: 9px !important;
    background-color: #54595F;
    color: #fff;
}

.budget-btn-money {
    border-top-left-radius: 9px !important;
    border-bottom-left-radius: 9px !important;
    background-color: #54595F;
    color: #fff;
}

.budget-btn-time {
    border-top-right-radius: 9px !important;
    border-bottom-right-radius: 9px !important;
    background-color: #54595F;
    color: #fff;
}

.alertIcon {
    font-size: 15px;
    color: #F00020;
}
.deleteBudget {
    font-size: 25px;
    color: #F00020;
    cursor: pointer;
}

.btn-create-budget {
    background-color: #54595F !important;
    align-items: center;
}

.modal-create-budget-header {
    margin: 1%;
}

.modal-create-budget-body {
    margin: 1%;
}

.modal-create-budget-footer {
    align-content: center;
    align-items: center;
    margin: 1%;
}

.btn-create-budget {
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    border-radius: 9px !important;
    text-transform: capitalize !important; 
}
.btn-delete-budget {
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    border-radius: 9px !important;
    text-transform: capitalize !important; 
}
.btn-delete-budget-confirm:hover {
    background-color: #F00020 !important;
    color: #000000 !important;
}
.alertBudget{
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Budget/style.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,WAAW;IACX,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;IAC3B,iCAAiC;IACjC,uBAAuB;IACvB,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;;;;;IAKI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,yCAAyC;IACzC,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;IAC1C,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,qCAAqC;AACzC;AACA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,qCAAqC;AACzC;AACA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".budget-btn {\n    display: inline-block;\n    background-color: #54595F !important;\n    color: #fff;\n    text-decoration: none;\n    font-size: 1.5rem !important;\n    font-weight: 600 !important;\n    padding: 0.8rem 3.5rem !important;\n    border: none !important;\n    cursor: pointer !important;\n    font-family: inherit !important;\n    transition: all 0.3s !important;\n}\n\n.btn-create-budget:hover,\n.btn-delete-budget-cancel:hover,\n.argent-background,\n.time-background,\n.budget-btn:hover {\n    background-color: #61CE70 !important;\n    color: #000000 !important;\n}\n\n.budget-btn-create {\n    border-radius: 9px !important;\n    background-color: #54595F;\n    color: #fff;\n}\n\n.budget-btn-money {\n    border-top-left-radius: 9px !important;\n    border-bottom-left-radius: 9px !important;\n    background-color: #54595F;\n    color: #fff;\n}\n\n.budget-btn-time {\n    border-top-right-radius: 9px !important;\n    border-bottom-right-radius: 9px !important;\n    background-color: #54595F;\n    color: #fff;\n}\n\n.alertIcon {\n    font-size: 15px;\n    color: #F00020;\n}\n.deleteBudget {\n    font-size: 25px;\n    color: #F00020;\n    cursor: pointer;\n}\n\n.btn-create-budget {\n    background-color: #54595F !important;\n    align-items: center;\n}\n\n.modal-create-budget-header {\n    margin: 1%;\n}\n\n.modal-create-budget-body {\n    margin: 1%;\n}\n\n.modal-create-budget-footer {\n    align-content: center;\n    align-items: center;\n    margin: 1%;\n}\n\n.btn-create-budget {\n    font-size: 1.5rem !important;\n    font-weight: 600 !important;\n    border-radius: 9px !important;\n    text-transform: capitalize !important; \n}\n.btn-delete-budget {\n    font-size: 1.5rem !important;\n    font-weight: 600 !important;\n    border-radius: 9px !important;\n    text-transform: capitalize !important; \n}\n.btn-delete-budget-confirm:hover {\n    background-color: #F00020 !important;\n    color: #000000 !important;\n}\n.alertBudget{\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
